// extracted by mini-css-extract-plugin
export default {"cartButton":"CartButton_cartButton__bCZFE"};